var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditItem',{attrs:{"model":"country","item":_vm.country,"status":_vm.status,"fields":_vm.fields}},[_c('FormCountryEdit',{attrs:{"item":_vm.country,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }